module.exports = __webpack_public_path__ + "img/sign-up-fee-icon.300acbc6.png";